import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing } = themeVariables;

const LOGO_SIZE = 48;

const block = css`
  background-color: color-mix(in srgb, var(${colors.content.link}) 12%, transparent);
`;

export const root = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.sm});
  padding: var(${spacing.md});
  animation: partner-mini-module-skeleton-pulse 1.2s ease-in-out infinite;

  @keyframes partner-mini-module-skeleton-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }
`;

export const detailsRow = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.sm});
`;

export const logo = css`
  ${block};
  flex-shrink: 0;
  width: ${LOGO_SIZE}px;
  height: ${LOGO_SIZE}px;
`;

export const textColumn = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: var(${spacing.xs});
`;

export const lineWide = css`
  ${block};
  width: 70%;
  height: 16px;
  border-radius: var(${spacing.xs});
`;

export const lineNarrow = css`
  ${block};
  width: 45%;
  height: 14px;
  border-radius: var(${spacing.xs});
`;

export const infoStrip = css`
  display: flex;
  gap: var(${spacing.md});
`;

export const infoItem = css`
  ${block};
  flex: 1 1 0;
  height: 40px;
  border-radius: var(${spacing.xs});
`;
